/* eslint-disable security/detect-object-injection */
import { ICoreContext } from '@msdyn365-commerce/core';
import { useEffect, useState } from 'react';

enum gridSettings {
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl'
}

export function isMobileView(context: ICoreContext, effectiveScope: gridSettings = gridSettings.sm): boolean {
    const { gridSettings } = context.request;
    const selectedScope = (gridSettings && gridSettings[effectiveScope] && gridSettings[effectiveScope]?.w) || 768;

    const [isMobile, setIsMobile] = useState<boolean>(typeof window !== 'undefined' ? window.innerWidth <= selectedScope : false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const onResize = () => {
                setIsMobile(window.innerWidth <= selectedScope);
            };
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        } else {
            return;
        }
    }, []);

    return isMobile;
}
